/** Default commission rate in basis points (50%). */
export const DEFAULT_COMMISSION_RATE_BASIS_POINTS = 5000;

/** Default days a referral stays claimable after the invite. */
export const DEFAULT_CLAIM_WINDOW_DAYS = 90;

/** Default months a referral earns commission after activation. */
export const DEFAULT_EARNING_WINDOW_MONTHS = 12;

/** Default days commission is held before it enters a statement. */
export const DEFAULT_HOLD_PERIOD_DAYS = 35;

/** Default minimum payable amount per statement, in cents. */
export const DEFAULT_MINIMUM_PAYOUT_CENTS = 5000;

/** Default number of invites a partner may send per day. */
export const DEFAULT_DAILY_INVITE_CAP = 50;

/** Length of the Pro trial a Pro-trial invite grants, in days. */
export const PRO_TRIAL_PERIOD_DAYS = 30;

/** Agreement version the backend currently requires partners to accept. */
export const PARTNER_AGREEMENT_VERSION = "2026-10-26";

/** Fewest addresses one invite request may carry. */
export const MIN_INVITE_EMAILS_PER_REQUEST = 1;

/** Most addresses one invite request may carry. */
export const MAX_INVITE_EMAILS_PER_REQUEST = 50;

/** Page size the partner and partner-admin lists request. */
export const PARTNER_LIST_PAGE_LIMIT = 25;

/** Placeholder rows a partner table shows while its first page loads. */
export const PARTNER_TABLE_SKELETON_ROW_COUNT = 3;

/** Test id of each placeholder row in a partner table's first-page skeleton. */
export const PARTNER_TABLE_SKELETON_ROW_TEST_ID = "partner-table-skeleton-row";
